import type { BreakpointKeys } from 'constants/_types/BreakpointKeys';

export const APP_BAR_DESKTOP_HEIGHT: Partial<Record<BreakpointKeys, string>> = {
  xl: '90px',
  xxl: '100px',
};
